// iGamingTruth mark: a quotation mark with three strokes, rotated 14deg.
// Every review is someone speaking; the third stroke says more than one person said it.
export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" className={className} aria-hidden="true">
      <g transform="rotate(14 48 48)" fill="#12766B">
        <rect x="17" y="27" width="14" height="42" rx="7" />
        <rect x="41" y="27" width="14" height="42" rx="7" />
        <rect x="65" y="27" width="14" height="42" rx="7" />
      </g>
    </svg>
  );
}

export function Logo({ size = 32, showTagline = false, className = "" }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <span className="flex flex-col leading-none">
        <span className="font-heading text-xl tracking-tight text-ink">
          <span className="font-medium">iGaming</span><span className="font-extrabold">Truth</span>
        </span>
        {showTagline && (
          <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.14em] text-slate-500">Verified reviews from inside iGaming</span>
        )}
      </span>
    </span>
  );
}
